import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {setLocale} from 'yup';
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
   en: {
      translation: enTranslation,
   },
   fr: {
      translation: frTranslation,
   },
};

export const languages = ['en', 'fr'];

i18n
   .use(initReactI18next) // passes i18n down to react-i18next
   .init({
      resources,
      lng: 'en',
      fallbackLng: 'en',

      keySeparator: false, // we do not use keys in form messages.welcome
      nsSeparator: false, // we do not use namespaces in form ns:messages.welcome

      interpolation: {
         escapeValue: false, // react already safes from xss
      },
   });

setLocale({
   string: {
      email: i18n.t('Must be a valid email'),
   },
});

export default i18n;
